module.exports = __webpack_public_path__ + "static/img/invest-consume2.b5e76a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume2.jpg
// module id = rxMP
// module chunks = 0